/* eslint-disable no-unused-vars */
// * https://firebase.google.com/docs/web/setup#available-libraries

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  Timestamp,
  doc,
  setDoc,
  getDocs,
  query,
  orderBy,
  limit,
  getDoc,
  where,
  startAfter,
  writeBatch,
  arrayUnion,
  updateDoc,
  deleteDoc,
  getCountFromServer,
  arrayRemove,
  serverTimestamp,
} from "firebase/firestore";
import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  updateProfile,
  signOut,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

// * Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEUR1Ft3iQnC0OlsPs_6-NNOHifJltyNk",
  authDomain: "magpie-journal.firebaseapp.com",
  projectId: "magpie-journal",
  storageBucket: "magpie-journal.appspot.com",
  messagingSenderId: "894340920056",
  appId: "1:894340920056:web:bbb7fca050499d88d4410d",
  measurementId: "G-2463E9XKP3",
};

// * Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app, "europe-west1");
const firestore = getFirestore(app);
// const storage = getStorage();
const auth = getAuth();
auth.useDeviceLanguage();
export { auth, onAuthStateChanged };

// * Add message to firestore
export async function sendMessage(name, email, phone, message) {
  try {
    const messagesCollection = collection(firestore, "messages");

    await addDoc(messagesCollection, {
      name,
      email,
      phone,
      message,
      status: "unread",
      date: Timestamp.now(),
    });

    return { success: true };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending message:", error);
    return { success: false, error: error.message || "An error occurred" };
  }
}

// * Function to subscribe an email
export async function subscribe(email) {
  try {
    // Reference to the "Email" collection
    const emailsCollection = collection(firestore, "subscribers");

    const queryRef = query(
      emailsCollection,
      where("email", "==", email),
      limit(1)
    );
    const querySnapshot = await getDocs(queryRef);
    if (querySnapshot.docs.length === 0) {
      // Add the email to the collection
      await addDoc(emailsCollection, { email });
      return { success: true };
    } else {
      return { success: false, error: "You are already subscribed" };
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error subscribing email:", error);
    return { success: false, error: error.message || "An error occurred" };
  }
}

// * Function to unsubscribe an email
export async function callUnsubscribe(email) {
  try {
    const unsubscribe = httpsCallable(functions, "unsubscribe");
    const result = await unsubscribe({ email });
    return { ...result.data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return { success: false, error: error.message || "An error occurred" };
  }
}

// * Function to request account deletion
export async function callRequestDelete(email) {
  try {
    const requestDelete = httpsCallable(functions, "requestDelete");
    const result = await requestDelete({ email });
    return { ...result.data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return { success: false, error: error.message || "An error occurred" };
  }
}

// * Function to delete account
export async function callDeleteAccount(uid) {
  try {
    const deleteAccount = httpsCallable(functions, "deleteAccount");
    const result = await deleteAccount({ uid });
    return { ...result.data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return { success: false, error: error.message || "An error occurred" };
  }
}
